// يفتح التقرير المطبوع (رواتب/حضور) بهوية الشركة — النافذة تُفتح قبل جلب البيانات.
import { toast } from "sonner";
import { customSalaryReport, salaryReport } from "../../api/payroll";
import { attendanceReport } from "../../api/attendanceReport";
import { openReportWindow } from "./openSalaryReport";
import { openAttendanceWindow } from "../attendance/openAttendanceReport";
import { closeWindow, preopenWindow } from "../reports/openShared";
import { pdfTicket } from "../../api/reportTicket";
import { logoDataUrl } from "../reports/useReportBrand";

const scopeOf = (filters) => ({
  ...(filters.branch_id && filters.branch_id !== "all" ? { branch_id: filters.branch_id } : {}),
  ...(filters.user_id && filters.user_id !== "all" ? { user_id: filters.user_id } : {}),
});

export const openPrintableReport = async (kind, filters, lang, brand, t) => {
  const win = preopenWindow();
  if (!win) {
    toast.error(t("salaryReport.popupBlocked"));
    return;
  }
  const custom = Boolean(filters.start && filters.end);
  const scope = scopeOf(filters);
  const ticketParams = {
    lang,
    ...(custom ? { start: filters.start, end: filters.end } : { month: filters.month }),
    ...scope,
  };
  try {
    // تذكرة الـPDF تُجلب في الخلفية؛ لا ننتظرها لعرض التقرير (كانت أبطأ شيء، خاصة في الإنتاج).
    const ticketPromise = pdfTicket(kind === "attendance" ? "attendance" : "payroll", ticketParams)
      .catch(() => null);
    const data = await (kind === "attendance"
      ? attendanceReport({
          month: custom ? filters.start.slice(0, 7) : filters.month || new Date().toISOString().slice(0, 7),
          lang, ...(custom ? { start: filters.start, end: filters.end } : {}), ...scope,
        })
      : custom
        ? customSalaryReport({ start: filters.start, end: filters.end, lang, ...scope })
        : salaryReport({ month: filters.month, lang, ...scope }));
    if (!data.employees?.length) {
      closeWindow(win);
      toast.error(t("salaryReport.noData"));
      return;
    }
    // فرع محدّد مختار؟ استخدم شعار الفرع (مع السقوط لشعار الشركة)؛ وجميع الفروع ⇒ شعار الشركة.
    const branchBrand = data.branch_logo
      ? { ...brand, logo: (await logoDataUrl(data.branch_logo)) || brand?.logo }
      : brand;
    const options = { custom, brand: branchBrand, win, pdfUrl: null, ticket: null, ticketPromise };
    if (kind === "attendance") openAttendanceWindow(data, lang, options);
    else openReportWindow(data, lang, options);
  } catch {
    closeWindow(win);
    toast.error(t("errors.generic"));
  }
};
